import { Link } from "gatsby"
import React from "react"
import Logo from "../images/logo.svg"
// import "../style/mobile-menu.css"

const MobileMenu = () => {
  return (
    <nav role="navigation" className="mobile-menu">
      <div className="menu-logo-mobile">
        <Link to="/" activeClassName="menu-link-home-active">
          <img src={Logo} alt="Bärkopf"></img>
        </Link>
      </div>

      <div id="menuToggle">
        <input type="checkbox" />
        <span></span>
        <span></span>
        <span></span>
        <ul id="menu">
          <li>
            <Link
              to="/wanderreisen"
              partiallyActive={true}
              className="menu-link-wanderreisen"
              activeClassName="menu-link-wanderreisen-active"
            >
              Wanderreisen
            </Link>
          </li>
          <li>
            <Link
              to="/segelkreuzfahrten"
              partiallyActive={true}
              className="menu-link-segelkreuzfahrten"
              activeClassName="menu-link-segelkreuzfahrten-active"
            >
              Segelkreuzfahrten
            </Link>
          </li>
          <li>
            <Link
              to="/golfreisen"
              partiallyActive={true}
              className="menu-link-golfreisen"
              activeClassName="menu-link-golfreisen-active"
            >
              Golfreisen
            </Link>
          </li>
          <li>
            <Link
              to="/blog"
              partiallyActive={true}
              className="menu-link-blog"
              activeClassName="menu-link-blog-active"
            >
              Blog
            </Link>
          </li>
          <li>
            <Link
              to="/ueber-uns"
              partiallyActive={true}
              className="menu-link-ueber-uns"
              activeClassName="menu-link-ueber-uns-active"
            >
              Über uns
            </Link>
          </li>
          <li>
            <Link
              to="/bewertungen"
              partiallyActive={true}
              className="menu-link-ueber-uns"
              activeClassName="menu-link-ueber-uns-active"
            >
              Bewertungen
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}

const Menu = (props) => (
  <header className={props.subMenu ? "has-sub-menu" : "sticky-header"}>
    <nav className="menu">
      <ul>
        <li className="menu-logo">
          <Link to="/" activeClassName="menu-link-home-active">
            <img src={Logo} alt="Bärkopf"></img>
          </Link>
        </li>
        <li>
          <Link
            to="/wanderreisen"
            partiallyActive={true}
            className="menu-link-wanderreisen"
            activeClassName="menu-link-wanderreisen-active"
          >
            <span>Wanderreisen</span>
          </Link>
        </li>
        <li>
          <Link
            to="/segelkreuzfahrten"
            partiallyActive={true}
            className="menu-link-segelkreuzfahrten"
            activeClassName="menu-link-segelkreuzfahrten-active"
          >
            <span>Segelkreuzfahrten</span>
          </Link>
        </li>
        <li>
          <Link
            to="/golfreisen"
            partiallyActive={true}
            className="menu-link-golfreisen"
            activeClassName="menu-link-golfreisen-active"
          >
            <span>Golfreisen</span>
          </Link>
        </li>
        <li>
          <Link
            to="/blog"
            partiallyActive={true}
            className="menu-link-blog"
            activeClassName="menu-link-blog-active"
          >
            <span>Blog</span>
          </Link>
        </li>
        <li>
          <Link
            to="/ueber-uns"
            className="menu-link-ueber-uns"
            activeClassName="menu-link-ueber-uns-active"
          >
            <span>Über uns</span>
          </Link>
        </li>
        <li>
          <Link
            to="/bewertungen"
            partiallyActive={true}
            className="menu-link-ueber-uns"
            activeClassName="menu-link-ueber-uns-active"
          >
            Bewertungen
          </Link>
        </li>
      </ul>
    </nav>
    <MobileMenu />
  </header>
)

export default Menu
